import React from 'react';
import { connect } from 'react-redux';
import { MenuItem } from 'react-contextmenu';
// @ts-ignore
import * as flowActions from 'store/services/flow/actions';
import { SContextMenu } from './TreeItem/styled';

interface Props {
  createNewTempFile: () => void;
  createNewTempFolder: () => void;
}

export const CONTEXT_MENU_ID = 'tree-empty-area';

function EmptySpaceContextMenu({
  createNewTempFile,
  createNewTempFolder,
}: Props) {
  return (
    <SContextMenu
      attributes={{ 'data-test': `${CONTEXT_MENU_ID}-context-menu` }}
      id={CONTEXT_MENU_ID}
    >
      <MenuItem
        attributes={{ 'data-test': `${CONTEXT_MENU_ID}-create-file` }}
        onClick={() => {
          createNewTempFile();
        }}
      >
        Create File
      </MenuItem>

      <MenuItem
        attributes={{ 'data-test': `${CONTEXT_MENU_ID}-create-folder` }}
        onClick={() => {
          createNewTempFolder();
        }}
      >
        Create Folder
      </MenuItem>
    </SContextMenu>
  );
}

export default connect(
  null,
  {
    createNewTempFile: flowActions.createNewTempFile,
    createNewTempFolder: flowActions.createNewTempFolder,
  },
)(EmptySpaceContextMenu);
